import { render, staticRenderFns } from "./PosNumberModifyDrawer.vue?vue&type=template&id=1a34f84b&scoped=true"
import script from "./PosNumberModifyDrawer.vue?vue&type=script&lang=js"
export * from "./PosNumberModifyDrawer.vue?vue&type=script&lang=js"
import style0 from "./PosNumberModifyDrawer.vue?vue&type=style&index=0&id=1a34f84b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a34f84b",
  null
  
)

export default component.exports